<template>
    <div class="professional-create-wrapper">
        <!-- Loading -->
        <loading />

        <!-- Professional Form Create -->
        <template v-if="!professionalSequenceData">
            <div class="default-professional-create-template">
                <h1 class="title-section heading-2">
                    Cria uma conta gratuitamente
                </h1>

                <form
                    @submit.prevent="getAccountLogin()"
                    aria-describedby="Professional Create"
                    method="post"
                    class="formcontent formcontent-professional-login"
                    autocomplete="off"
                >
                    <div class="create-form-wrapper">
                        <!-- email -->
                        <div class="item-wrapper">
                            <label for="email" class="form-label">Email</label>
                            <input
                                v-model="email"
                                type="email"
                                class="form-control"
                                id="email"
                                aria-describedby="Professional Email"
                                @focusin="inputValidationCase('email', email)"
                                @focusout="inputValidationCase('email', email)"
                                maxlength="300"
                            />
                        </div>

                        <!-- passowrd -->
                        <div class="item-wrapper">
                            <label for="password" class="form-label"
                                >Password</label
                            >

                            <div class="input-wrapper">
                                <input
                                    v-model="password"
                                    type="password"
                                    class="form-control"
                                    id="password"
                                    @keyup="
                                        checkPasswordStructure(
                                            password,
                                            'check-password',
                                            $event
                                        )
                                    "
                                    @focusin="
                                        inputValidationCase(
                                            'password',
                                            password
                                        ),
                                            showCheckPasswordContainer(
                                                'check-password'
                                            )
                                    "
                                    @focusout="
                                        inputValidationCase(
                                            'password',
                                            password
                                        ),
                                            hideCheckPasswordContainer(
                                                'check-password'
                                            )
                                    "
                                    maxlength="50"
                                    ref="password"
                                />
                                <span
                                    @click="
                                        showHidePass($refs.password, $event)
                                    "
                                    data-show="true"
                                    class="showpass toggle-password"
                                ></span>

                                <!-- Confirm Passsword Container -->
                                <confirm-container />
                            </div>
                        </div>

                        <!-- confirm password -->
                        <div class="item-wrapper">
                            <div class="d-flex flex-column">
                                <div
                                    class="d-flex flex-row justify-content-between"
                                >
                                    <label for="password" class="form-label"
                                        >Confirm Password</label
                                    >
                                </div>
                            </div>
                            <div class="input-wrapper">
                                <input
                                    v-model="confirmpassword"
                                    type="password"
                                    class="form-control"
                                    id="confirmpassword"
                                    @focusin="
                                        inputValidationCase(
                                            'confirmpassword',
                                            confirmpassword
                                        )
                                    "
                                    @focusout="
                                        inputValidationCase(
                                            'confirmpassword',
                                            confirmpassword
                                        )
                                    "
                                    maxlength="50"
                                    ref="confirmpassword"
                                />
                                <span
                                    @click="
                                        showHidePass(
                                            $refs.confirmpassword,
                                            $event
                                        )
                                    "
                                    data-show="true"
                                    class="showpass toggle-password"
                                ></span>
                            </div>
                            <p class="caption-md color-text-body password-note">
                                *{{ passwordindicate }}
                            </p>
                        </div>

                        <!-- botao -->
                        <div class="item-wrapper">
                            <button
                                type="submit"
                                class="btn btn-primary btn-filled-blue button-body"
                                :disabled="disabled"
                            >
                                Criar Conta
                            </button>
                        </div>
                    </div>

                    <div class="or-login">
                        <div class="line"></div>
                        <p class="color-text-body">ou</p>
                        <div class="line"></div>
                    </div>

                    <div class="login-now-wrapper">
                        <p>Já tens uma conta ?</p>
                        <a
                            class="button-body"
                            :href="loginurl"
                            target="_self"
                            aria-describedby="Professional Login"
                            >Iniciar sessão</a
                        >
                    </div>
                </form>
            </div>
        </template>

        <!-- Professional Form Data -->
        <template v-else>
            <div class="register-form-steps-wrapper">
                <!-- Header Menu -->
                <header class="professional-header-account">
                    <nav>
                        <ul class="create-account-steps-wrapper">
                            <li
                                @click="chooseSequence($event)"
                                role="button"
                                class="professional-onboard-button create-account-step"
                                data-routine="perfil"
                            >
                                <div
                                    class="create-account-step-item"
                                    data-routine="perfil"
                                >
                                    <span
                                        class="profile-item span-wrapper"
                                        data-routine="perfil"
                                    >
                                        <img
                                            :src="`${iconpathdefault}/current.svg`"
                                            alt="icon"
                                            data-routine="perfil"
                                        />
                                    </span>
                                    <p class="caption-lg" data-routine="perfil">
                                        Perfil
                                    </p>
                                </div>
                            </li>

                            <div class="line"></div>

                            <li
                                @click="chooseSequence($event)"
                                role="button"
                                class="professional-onboard-button create-account-step disable-point-event"
                                data-routine="contrato"
                                disabled="disabled"
                            >
                                <div
                                    class="create-account-step-item"
                                    data-routine="contrato"
                                >
                                    <span
                                        class="consent-item span-wrapper"
                                        data-routine="contrato"
                                    >
                                        <!-- <img
                                            src="images/icons/checkout/current.svg"
                                            alt="icon"
                                        /> -->
                                    </span>
                                    <p
                                        class="caption-lg"
                                        data-routine="contrato"
                                    >
                                        Consentimento
                                    </p>
                                </div>
                            </li>

                            <div class="line"></div>

                            <li
                                @click="chooseSequence($event)"
                                role="button"
                                class="professional-onboard-button create-account-step disable-point-event"
                                data-routine="categoria"
                                disabled="disabled"
                            >
                                <div
                                    class="create-account-step-item"
                                    data-routine="categoria"
                                >
                                    <span
                                        class="ocupation-item span-wrapper"
                                        data-routine="categoria"
                                    >
                                        <!-- <img
                                            src="images/icons/checkout/current.svg"
                                            alt="icon"
                                        /> -->
                                    </span>
                                    <p
                                        class="caption-lg"
                                        data-routine="categoria"
                                    >
                                        Ocupação
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </header>

                <!-- Content -->
                <div class="professional-content-account">
                    <!-- Professional Form Data -->
                    <div class="professional-account" data-content="perfil">
                        <professional-form
                            routine="website"
                            :validation="inputValidationCase"
                            :disabled="disabled"
                            :onboardsequence="onBoardSequenceByRoutine"
                            @form-data="getProfessionalAccountData($event)"
                            :imgdefaultaccount="imgdefault"
                            :imgdefaultpath="imgdefaultpath"
                            :renderMessage="renderResponseMessageMethod"
                        />
                    </div>

                    <!-- Professional Contract -->
                    <div
                        class="professional-account d-none"
                        data-content="contrato"
                    >
                        <contract
                            v-if="activadeContractComponent"
                            :onboardsequence="onBoardSequenceByRoutine"
                            @form-data="getProfessionalAgreement($event)"
                            :contracttext="contract"
                            :professionaldata="contractProfessionalData"
                        />
                    </div>

                    <!-- Professional Category -->
                    <div
                        class="professional-account d-none"
                        data-content="categoria"
                    >
                        <professional-category
                            @form-data="getProfessionalCategories($event)"
                            :categorylist="categories"
                            :categorypathimg="categorypathimg"
                            :renderMessage="renderResponseMessageMethod"
                        />
                    </div>
                </div>
            </div>
        </template>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </div>
</template>

<script>
//Set Use Strict
"use strict";

import fetchData from "./../../../fetchData.js";
import inputValidation from "./../../../validationInputs.js";
import Loading from "./../../elements/LoadingElement.vue";
import ListMessage from "./../../elements/ListMessageElement.vue";
import ProfessionalCreateForm from "./ProfessionalCreateForm.vue";
import Contract from "./Contract.vue";
import ProfessionalCategory from "./ProfessionalCategory.vue";
import responseMessage from "./../../../responseMessage";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import htmlElements from "../../../htmlElements.js";
import ConfirmPassContainer from "./../../elements/confirmPasswordContainer.vue";

export default {
    name: "ProfessionalCreate",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        loginurl: {
            type: String,
            required: true,
        },
        imgdefault: {
            type: String,
            required: true,
        },
        routineurl: {
            type: String,
            required: true,
        },
        adminurl: {
            type: String,
            required: true,
        },
        checkvaluesurl: {
            type: String,
            required: true,
        },
        contract: {
            type: String,
            required: true,
        },
        categories: {
            type: String,
            required: true,
        },
        iconpathdefault: {
            type: String,
            required: true,
        },
        categorypathimg: {
            type: String,
            required: true,
        },
        passwordindicate: {
            type: String,
            required: true,
        },
        imgdefaultpath: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            email: "",
            password: "",
            confirmpassword: "",
            disabled: true,
            activeclass: "d-flex",
            inputNotIsValid: true,
            professionalData: {
                login: {},
                account: {},
                contract: false,
                contractfile: "",
                categories: [],
            },
            contractProfessionalData: {},
            professionalSequenceData: false,
            activadeContractComponent: false,
            checkPasswordData: [],
            checkPasswordTypes: [],
        };
    },
    created() {
        //Set Confirm Passwords Patterns
        this.checkPasswordTypes = inputValidation.confirmPasswordPatterns();
    },
    mounted() {},
    methods: {
        renderResponseMessageMethod(message, classname = "danger") {
            //Render Response Message
            responseMessage.renderResponseMessages(
                this.$refs.responsebasemessage,
                classname,
                message,
                this.activeclass
            );
        },
        checkPasswordStructure(password, elementbase, element) {
            //Clean Data
            if (element.key === "Backspace") {
                this.checkPasswordData = [];

                //Remove all Icons
                if (document.querySelector(".check-password-icon")) {
                    [
                        ...document.querySelectorAll(".check-password-icon"),
                    ].forEach((value) => value.remove());
                }
            }

            if (
                (password !== "" && element.key !== "Backspace") ||
                element.key !== "Shift" ||
                element.key !== "CapsLock"
            ) {
                //Execute Confirm Password
                this.checkPasswordData = inputValidation.confirmPassword(
                    password,
                    elementbase
                );

                if (this.checkPasswordData.length > 0) {
                    //Set Confirm Password Element
                    inputValidation.confirmPasswordAddIcon(
                        elementbase,
                        this.checkPasswordData
                    );

                    //Disable Button Conditional
                    this.disabled = true;
                }
            }
        },
        showCheckPasswordContainer(elementbase) {
            if (this.checkPasswordData.length > 0) {
                //Set Confirm Password Element
                inputValidation.confirmPasswordAddIcon(
                    elementbase,
                    this.checkPasswordData
                );

                //Disable Button Conditional
                this.disabled = true;
            }

            //Show Base Element
            document
                .getElementById(`${elementbase}`)
                .classList.remove("d-none");
            document.getElementById(`${elementbase}`).classList.add("d-flex");
        },
        hideCheckPasswordContainer(elementbase) {
            //Remove all Icons
            if (document.querySelector(".check-password-icon")) {
                [...document.querySelectorAll(".check-password-icon")].forEach(
                    (value) => value.remove()
                );
            }

            //Hide Base Element
            document
                .getElementById(`${elementbase}`)
                .classList.remove("d-flex");
            document.getElementById(`${elementbase}`).classList.add("d-none");
        },
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        getAccountLogin() {
            //Check Data
            if (
                this.email === "" ||
                this.password === "" ||
                this.confirmpassword === ""
            ) {
                //Disabled BTN
                this.disabled = true;

                //Send Message
                this.renderResponseMessageMethod(
                    "Necessário preencher todos os campos"
                );

                return;
            }

            //Check Password
            if (this.password !== this.confirmpassword) {
                //Disabled Button
                this.disabled = true;

                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "O password e o confirm password não são equivalentes",
                    this.activeclass
                );

                return;
            }

            //Set Profissional Data
            this.professionalData.login.email = this.email.trim();
            this.professionalData.login.password = this.password.trim();

            //Disabled BTN
            this.disabled = true;

            //Check Email
            this.checkValues(this.professionalData.login);
        },
        inputValidationCase(inputid, inputvalue) {
            //Check Value
            if (inputvalue === "") {
                //Disabled Button
                this.disabled = true;

                return;
            }

            //Check Inputs
            switch (inputid) {
                //Name
                case "name":
                    this.disabled = inputValidation.validNameCases(
                        1,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //Address
                case "address":
                case "address_billing":
                    this.disabled = inputValidation.validNameCases(
                        4,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //Email
                case "email":
                    this.disabled = inputValidation.validNameCases(
                        7,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //Contact
                case "contact":
                    this.disabled = inputValidation.validNameCases(
                        2,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //Postalcode
                case "postalcode":
                case "postalcode_billing":
                    this.disabled = inputValidation.validNameCases(
                        2,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //Password
                case "password":
                case "confirmpassword":
                    this.disabled = inputValidation.validNameCases(
                        11,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //City
                case "city":
                case "city_billing":
                    this.disabled = inputValidation.validNameCases(
                        1,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //Nif
                case "nif":
                    
                    //Check Length
                    if (inputvalue.toString().length === 9) {
                        this.disabled = inputValidation.validNameCases(
                            12,
                            inputvalue
                        )
                            ? false
                            : true;

                        //Check Nif structure
                        if(!this.disabled){

                            this.disabled = inputValidation.isValidNif(inputvalue);

                        }

                    } else {
                        this.disabled = true;
                    }    

                    break;
            }

            //Set Conditional for input is valid
            this.inputNotIsValid = this.disabled;

            //Show Error Message
            if (this.disabled) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },
        chooseSequence(element) {
            //Get Routine
            let routine = element.currentTarget.getAttribute("data-routine");

            //List all Routine Content
            let routineContent = [
                ...document.querySelectorAll(".professional-account"),
            ];

            //Show or Hide Content
            routineContent.forEach((value) => {
                //Check Content
                if (value.getAttribute("data-content") === routine) {
                    //Check content routine
                    if (value.classList.contains("d-none")) {
                        value.classList.remove("d-none");
                    }
                } else {
                    value.classList.add("d-none");
                }
            });
        },
        showHidePass(inputelement, element) {
            //Execute Default Show|Hide Password method
            defaultWebsite.showPassword(inputelement, element.target);
        },
        onBoardSequenceByRoutine(onboardRoutine) {
            //Get all onboard buttons
            let onBoardButtons = [
                ...document.querySelectorAll(".professional-onboard-button"),
            ];

            //Get Specifc Onboard Button
            let onBoardButton = onBoardButtons.find(
                (value) => value.getAttribute("data-routine") === onboardRoutine
            );

            //Check OnBoard Button
            if (onBoardButton !== undefined) {
                //Add Icon
                [...document.querySelectorAll(".span-wrapper")].forEach(
                    (value) => {
                        if (
                            value.firstElementChild === null &&
                            onBoardButton.getAttribute("data-routine") ===
                                value.getAttribute("data-routine")
                        ) {
                            let iconimg = htmlElements.createElement("img", {
                                src: `${this.iconpathdefault}/current.svg`,
                                alt: "Icon",
                            });

                            value.appendChild(iconimg);
                        }
                    }
                );

                //Enable Button
                onBoardButton.classList.remove("disable-point-event");

                //List all Routine Content
                let routineContent = [
                    ...document.querySelectorAll(".professional-account"),
                ];

                //Show Related Content
                let content = routineContent.find(
                    (value) =>
                        value.getAttribute("data-content") === onboardRoutine
                );

                //Hide the Previus Sibling
                content.previousElementSibling.classList.add("d-none");

                //Show the Current Content
                content.classList.remove("d-none");
            }
        },
        getProfessionalAccountData(data) {
            //Set Accound Form Data
            Object.assign(this.professionalData.account, data);

            //Set Contract Professional Data
            this.contractProfessionalData = {
                name: btoa(this.professionalData.account.data.name),
                address: btoa(
                    this.professionalData.account.data.address +
                        ", Código Postal: " +
                        this.professionalData.account.data.postalcode +
                        ", " +
                        this.professionalData.account.data.city
                ),
                nif: btoa(this.professionalData.account.data.nif),
            };

            //Actived Contract Component
            this.activadeContractComponent = true;

            //Set Professional Data
            //sessionStorage.setItem("professionalData", JSON.stringify(this.contractProfessionalData));
        },
        getProfessionalAgreement(agree) {
            //Get Contract Data
            this.professionalData.contractfile = agree.contract;

            //Set User Agreement
            this.professionalData.contract = agree.agreement;
        },
        getProfessionalCategories(data) {
            //Get Professional Categories
            this.professionalData.categories = data;

            //Send data
            this.sendData(this.professionalData, this.routineurl);
        },
        sendData(formData, url, method = "POST") {
            //Disabled Button
            this.disabled = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Send Data
            let response = fetchData.structureTosendData(
                url,
                formData,
                this.csrftolken,
                method
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Enabled Button
                    this.disabled = false;

                    //Add active Class
                    this.$refs.responsebasemessage.classList.add(
                        this.activeclass
                    );
                    this.$refs.responsebasemessage.classList.add(
                        value.classname
                    );

                    //Check Type
                    if (Array.isArray(value.message)) {
                        value.message.forEach((valmsg) => {
                            //Element for append
                            let li = responseMessage.messageStructure(
                                valmsg,
                                value.classname
                            );

                            //Append Element
                            $(li).appendTo(
                                this.$refs.responsebasemessage.children
                            );
                        });

                        return;
                    }

                    //Element for append
                    let li = responseMessage.messageStructure(
                        value.message,
                        value.classname
                    );

                    //Append Element
                    $(li).appendTo(this.$refs.responsebasemessage.children);

                    //Remove Message
                    responseMessage.removeResponseMessages();

                    //Redirect User
                    if (Object.is(value.classname, "success")) {
                        //Redirect for Admin Route
                        window.location.replace(this.adminurl);
                    }

                    return;
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
        checkValues(formData) {
            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Send Data
            let response = fetchData.structureTosendData(
                this.checkvaluesurl,
                formData,
                this.csrftolken,
                "PATCH"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Check Conditional
                    if (Object.is(value.classname, "danger")) {
                        //Add active Class
                        this.$refs.responsebasemessage.classList.add(
                            this.activeclass
                        );
                        this.$refs.responsebasemessage.classList.add("danger");

                        //Element for append
                        let li = responseMessage.messageStructure(
                            value.message,
                            value.classname
                        );

                        //Append Element
                        $(li).appendTo(this.$refs.responsebasemessage.children);

                        //Remove Message
                        responseMessage.removeResponseMessages(10000);

                        return;
                    }

                    //Set Sequence Professional Data
                    this.professionalSequenceData = true;
                })
                .catch((error) => {
                    throw new Error(error);
                });

            return false;
        },
    },
    computed: {
        professionalDataComputed() {
            return this.professionalData;
        },
        professionalSequenceDataComputed() {
            return this.professionalSequenceData;
        },
        disabledComputed() {
            return this.disabled;
        },
        contractProfessionalDataComputed() {
            return this.contractProfessionalData;
        },
    },
    watch: {
        professionalDataComputed() {},
        professionalSequenceDataComputed() {},
        disabledComputed() {},
        contractProfessionalDataComputed() {},
    },
    components: {
        loading: Loading,
        listMessage: ListMessage,
        professionalForm: ProfessionalCreateForm,
        contract: Contract,
        professionalCategory: ProfessionalCategory,
        confirmContainer: ConfirmPassContainer,
    },
    destroyed() {
        //Remove Session Storage
        //sessionStorage.removeItem('professionalData');
    },
};
</script>
